
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Aldo R., décédé le 3 décembre 2020</b>
    <br />
    <br />
    <i>L’avis mortuaire raconte: </i>
    <br />
    <p>
  «L'histoire de sa vie a été marquée par une vie simple, par la résistance en
  Italie, par son exil, ses joies personnelles et ses coups du sort, sa
  profession, son jardinage bien-aimé et son intérêt sans fin pour la politique.
  Maintenant, nous lui disons "ciao pour toujours...»
    </p>
    <i>L’avis mortuaire raconte: </i>
    <br />
    <p>
  «Un samedi, ils ont dit que tous les résidents avaient été testés. Nous avons
  attendu deux jours pour avoir le résultat positif du test qui nous a été
  communiqué par téléphone. On nous a dit : "Nous sommes désolés, votre père va
  en mourir". Cela été un choc. Nous étions déjà éprouvés par la maladie. Le
  jour même de l’annonce, nous lui avons rendu visite dans sa maison de
  retraite. Après avoir endossé les vêtements de protection, nous avons pu lui
  dire au revoir une dernière fois. Mon papa n'a pas réagi. Il est décédé peu
  après. Pour nous, la situation est encore surréaliste»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;